import queries from '@apis/queries';
import useTestUser from '@hooks/test/useTestUser';
import { useQuery } from '@tanstack/react-query';

function useRecentOrders() {
  const { data } = useQuery(queries.orders.recent());
  const isTestUser = useTestUser();
  const { data: testShopResponse } = useQuery(queries.project.testShops());
  return data?.orders.filter((order) => {
    const { shopId } = order;
    if (testShopResponse?.shopIds?.includes(shopId)) {
      return isTestUser;
    }
    return true;
  });
}

export default useRecentOrders;
